// import React, { useEffect, useState } from 'react'
// import { Container, Row, Col, Card } from 'react-bootstrap'
// import EarthOne from '../Assets/Assests/Hand-Earth-1.png'
// import EarthTwo from '../Assets/Assests/Hand-Earth-2.png'
// import EarthThree from '../Assets/Assests/Hand-Earth-3.png'
// import Face from '../Assets/Assests/face-pot.png'
// import HelpingGirl from '../Assets/Assests/Helping-girl.png'
// import gif from '../Assets/Assests/hii-circle-gif.gif'
// import Man from '../Assets/Assests/man-collaboration.png'
// import Doctor from '../Assets/Assests/female-doctor.jpg'
// import Header from './Header'
// import Footer from './Footer'
// import { Link, useNavigate } from 'react-router-dom'

// const NewLandingPage = () => {
//   const navigate = useNavigate()

//   const images = [EarthOne, EarthTwo, EarthThree]
//   const [currentIndex, setCurrentIndex] = useState(0)
//   const [fade, setFade] = useState(true)
//   const [isDonateHovered, setIsDonateHovered] = useState(false)
//   const [isMemberHovered, setIsMemberHovered] = useState(false)
//   const [isMemberTwoHovered, setIsMemberTwoHovered] = useState(false)
//   const [isEnquireHovered, setIsEnquireHovered] = useState(false)

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setFade(false) // start fade out

//       setTimeout(() => {
//         setCurrentIndex((prev) => (prev + 1) % images.length)
//         setFade(true) // start fade in
//       }, 300) // fade out duration
//     }, 3000) // time each image stays on screen

//     return () => clearInterval(interval)
//   }, [])

//   return (
//     <>
//       <Header />

//       <div className='min-h-screen' style={{ backgroundColor: '#2D5272' }}>
//         <header
//           id='home'
//           className='container-fluid text-white py-5'
//           style={{ background: '#2D5272' }}
//         >
//           <div className='container'>
//             <div
//               className='row align-items-center'
//               style={{ minHeight: '60vh', marginTop: '50px' }}
//             >
//               <div className='col-lg-6'>
//                 <h1
//                   className='fst-normal mb-4'
//                   style={{
//                     marginTop: '10px',
//                     fontFamily: 'Inter',
//                     fontWeight: '700',
//                     fontSize: '54px',
//                   }}
//                 >
//                   Wellness initiatives, reimagined for today’s world.
//                 </h1>
//                 <p className='mb-4' style={{ opacity: '2', zIndex: 3 }}>
//                   Tesla Bird is India’s first AI-powered mental wellness
//                   platform inspired by the genius and struggles of Nikola Tesla.
//                 </p>
//                 <p className='mt-4' style={{ opacity: '2', zIndex: 3 }}>
//                   Join hands in shaping a kinder, stronger, and more mentally
//                   aware society.
//                 </p>
//                 {/* <div className='d-flex gap-3'>
//                   <button
//                     className='btn px-4 py-1'
//                     style={{
//                       backgroundColor: '#002740',
//                       color: 'white',
//                       borderRadius: '50px',
//                       textDecoration: 'none',
//                       width: '108px',
//                       height: '53px',
//                     }}
//                     onClick={() => navigate('/donate-form')}
//                   >
//                     Donate
//                   </button>

//                   <Link
//                     to='/sign-in'
//                     className='btn px-4 py-2'
//                     style={{
//                       border: '2px solid #FFFFFF',
//                       color: '#FFFFFF',
//                       borderRadius: '50px',
//                       textDecoration: 'none',
//                       width: '197px',
//                       height: '53px',
//                     }}
//                   >
//                     Become a Member
//                   </Link>
//                 </div> */}
//                 <div className='d-flex gap-3'>
//                   {/* Donate Button */}
//                   <button
//                     className='btn px-4 py-1'
//                     style={{
//                       backgroundColor: '#002740',
//                       color: 'white',
//                       borderRadius: '50px',
//                       textDecoration: isDonateHovered ? 'underline' : 'none',
//                       width: '108px',
//                       height: '53px',
//                       transition: 'all 0.3s ease',
//                     }}
//                     onMouseEnter={() => setIsDonateHovered(true)}
//                     onMouseLeave={() => setIsDonateHovered(false)}
//                     onClick={() => navigate('/donate-form')}
//                   >
//                     Donate
//                   </button>

//                   {/* Become a Member Button */}
//                   <Link
//                     to='/membership'
//                     className='btn px-4 py-2'
//                     style={{
//                       display: 'flex',
//                       justifyContent: 'center',
//                       alignItems: 'center',
//                       border: '2px solid #FFFFFF',
//                       color: '#FFFFFF',
//                       borderRadius: '50px',
//                       textDecoration: isMemberHovered ? 'underline' : 'none',
//                       width: '197px',
//                       height: '53px',
//                       transition: 'all 0.3s ease',
//                     }}
//                     onMouseEnter={() => setIsMemberHovered(true)}
//                     onMouseLeave={() => setIsMemberHovered(false)}
//                   >
//                     Become a Member
//                   </Link>
//                 </div>
//               </div>

//               {/* Animated Image Section */}
//               <div className='col-md-6 d-flex justify-content-center position-relative'>
//                 <div
//                   className='image-wrapper'
//                   style={{
//                     width: '90%',
//                     height: '400px',
//                     position: 'relative',
//                     overflow: 'hidden',
//                   }}
//                 >
//                 <img
//                   src={images[currentIndex]}
//                   alt='Hero'
//                   className='img-fluid'
//                   style={{
//                     zIndex: 2,
//                     width: '80%',
//                     height: '100%',
//                     objectFit: 'cover',
//                     opacity: fade ? 1 : 0,
//                     transition: 'opacity 0.5s ease-in-out',
//                     position: 'absolute',
//                     top: 0,
//                     left: 0,
//                   }}
//                 />
//                 </div>
//                 {/* <div
//                   className='image-wrapper'
//                   style={{
//                     width: '90%',
//                     height: '400px',
//                     position: 'relative',
//                     overflow: 'hidden',
//                   }}
//                 >
//                   {currentIndex === 1 ? (
//                     <>

//                       <img
//                         src={images[1]}
//                         alt='Upper Half'
//                         style={{
//                           position: 'absolute',
//                           top: 0,
//                           left: 0,
//                           width: '80%',
//                           height: '50%',
//                           objectFit: 'cover',
//                           zIndex: 2,
//                           opacity: fade ? 1 : 0,
//                           transform: fade
//                             ? 'translateX(0)'
//                             : 'translateX(100%)',
//                           transition:
//                             'transform 0.5s ease-in-out, opacity 0.5s ease-in-out',
//                         }}
//                       />

//                       <img
//                         src={images[1]}
//                         alt='Lower Half'
//                         style={{
//                           position: 'absolute',
//                           bottom: 0,
//                           left: 0,
//                           width: '80%',
//                           height: '50%',
//                           objectFit: 'cover',
//                           zIndex: 2,
//                           opacity: fade ? 1 : 0,
//                           transform: fade
//                             ? 'translateX(0)'
//                             : 'translateX(-100%)',
//                           transition:
//                             'transform 0.5s ease-in-out, opacity 0.5s ease-in-out',
//                         }}
//                       />
//                     </>
//                   ) : (
//                     <img
//                       src={images[currentIndex]}
//                       alt='Hero'
//                       className='img-fluid'
//                       style={{
//                         zIndex: 2,
//                         width: '80%',
//                         height: '100%',
//                         objectFit: 'cover',
//                         opacity: fade ? 1 : 0,
//                         transition: 'opacity 0.5s ease-in-out',
//                         position: 'absolute',
//                         top: 0,
//                         left: 0,
//                       }}
//                     />
//                   )}
//                 </div> */}
//               </div>
//             </div>
//           </div>
//         </header>

//         <div className='container-fluid' style={{ backgroundColor: '#fff' }}>
//           <div className='container py-1'>
//             <h1
//               className='fst-normal mb-2'
//               style={{
//                 marginTop: '30px',
//                 fontFamily: 'Inter',
//                 fontWeight: '600',
//                 fontSize: '45px',
//                 color: '#2D5272',
//               }}
//             >
//               Tesla Bird Mental Wellness Initiative –{' '}
//               <span
//                 className='mb-2'
//                 style={{
//                   fontFamily: 'Inter',
//                   fontWeight: '600',
//                   fontSize: '45px',
//                   color: '#889E7E',
//                 }}
//               >
//                 A Stronger Mind for a Better Tomorrow
//               </span>
//             </h1>
//             <div
//               className='row align-items-center'
//               style={{
//                 minHeight: '80vh',
//                 marginTop: '30px',
//                 // marginBottom: "50px",
//               }}
//             >
//               <div className='col-lg-6'>
//                 <p
//                   className='mb-4'
//                   style={{
//                     opacity: '2',
//                     zIndex: 3,
//                     color: '#002740',
//                     fontFamily: 'Inter',
//                     fontWeight: '400',
//                     fontSize: '18px',
//                   }}
//                 >
//                   In today’s fast-paced world, mental wellness is one of the
//                   most urgent challenges—especially in India, where stress,
//                   anxiety, and burnout have reached alarming levels. Tesla Bird
//                   is a revolutionary AI-powered platform designed to tackle this
//                   crisis by blending advanced technology, scientific research,
//                   and human empathy.
//                 </p>
//                 <p
//                   className='mb-4'
//                   style={{
//                     opacity: '2',
//                     zIndex: 3,
//                     color: '#002740',
//                     fontFamily: 'Inter',
//                     fontWeight: '400',
//                     fontSize: '18px',
//                   }}
//                 >
//                   Named in honor of Nikola Tesla—who, despite his brilliance,
//                   struggled with nervous disorders and emotional
//                   breakdowns—Tesla Bird aims to do for mental health what Tesla
//                   did for electricity: bring light. We strive to illuminate
//                   minds with peace, purpose, and emotional strength.
//                 </p>
//                 <p
//                   className='mb-4'
//                   style={{
//                     opacity: '2',
//                     zIndex: 3,
//                     color: '#002740',
//                     fontFamily: 'Inter',
//                     fontWeight: '400',
//                     fontSize: '18px',
//                   }}
//                 >
//                   India’s mental health crisis is escalating rapidly. According
//                   to NIMHANS, 1 in 7 Indians suffers from some form of mental
//                   disorder. Students face intense academic pressure and social
//                   expectations, while professionals battle long hours, digital
//                   fatigue, and poor work-life balance—leading to anxiety,
//                   depression, and sleep issues. A 2024 WHO report ranked India
//                   among the top five most stressed nations globally.
//                 </p>
//                 <div className='d-flex gap-3'>
//                   <button
//                     className='btn px-4 py-1'
//                     style={{
//                       backgroundColor: '#002740',
//                       color: 'white',
//                       borderRadius: '50px',
//                       textDecoration: isDonateHovered ? 'underline' : 'none',
//                       width: '108px',
//                       height: '53px',
//                       transition: 'all 0.3s ease',
//                     }}
//                     onMouseEnter={() => setIsDonateHovered(true)}
//                     onMouseLeave={() => setIsDonateHovered(false)}
//                     onClick={() => navigate('/donate-form')}
//                   >
//                     Donate
//                   </button>
//                   <Link
//                     to='/membership'
//                     className='btn px-4 py-2'
//                     style={{
//                       border: '2px solid #889E7E',
//                       borderColor: isMemberTwoHovered ? '#889E7E' : 'none',
//                       backgroundColor: isMemberTwoHovered
//                         ? '#002740'
//                         : 'transparent',
//                       color: '#889E7E',
//                       borderRadius: '50px',
//                       textDecoration: 'none',
//                       width: '197px',
//                       height: '53px',
//                       borderWidth: '2px',
//                     }}
//                   >
//                     Become a Member
//                   </Link>
//                 </div>
//               </div>
//               {/* Images */}
//               <div className='col-md-6 d-flex justify-content-center position-relative'>
//                 <div className='position-relative d-none d-md-block'>
//                   <img
//                     src={Face}
//                     alt='face'
//                     className='img-fluid'
//                     style={{
//                       zIndex: 2,
//                       maxWidth: '90%',
//                       height: 'auto',
//                     }}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div
//           className='container-fluid p-0'
//           style={{ backgroundColor: 'white' }}
//         >
//           {/* Aarava Section */}
//           <div className='container py-3'>
//             <div
//               className='row'
//               style={{
//                 backgroundColor: '#E3F2FD',
//                 minHeight: '300px',
//                 padding: '40px 0',
//                 margin: '0',
//               }}
//             >
//               <div className='col-12'>
//                 <div className='container'>
//                   <div className='row align-items-center'>
//                     <div className='col-lg-8 col-md-7 col-12 mb-4 mb-md-0'>
//                       <h1
//                         className='mb-4'
//                         style={{
//                           fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
//                           fontWeight: '600',
//                           lineHeight: '140%',
//                           fontFamily: 'Inter',
//                         }}
//                       >
//                         <span style={{ color: '#2D5272' }}>Aarava- </span>
//                         <span style={{ color: '#889E7E' }}>
//                           AI Wellness Companion
//                         </span>
//                       </h1>
//                       <p
//                         style={{
//                           fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
//                           lineHeight: '180%',
//                           color: '#424242',
//                           maxWidth: '100%',
//                           wordWrap: 'break-word',
//                           fontFamily: 'Inter',
//                           fontWeight: '400',
//                           color: '#002740',
//                         }}
//                       >
//                         At the heart of Tesla Bird is Aarava—our AI-powered
//                         therapy companion that's here for you, 24/7, in the
//                         languages you feel most at home with. Aarava gently
//                         blends proven techniques like Cognitive Behavioral
//                         Therapy (CBT), mindfulness, and behavioral
//                         nudging—shaped to fit the emotional rhythms and cultural
//                         realities of life in India and beyond.
//                       </p>
//                     </div>
//                     <div className='col-lg-4 col-md-5 col-12 d-flex justify-content-center'>
//                       <img
//                         src={gif}
//                         alt='Loading...'
//                         style={{ maxWidth: '100%' }}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Community Medicine Section */}
//           <div
//             className='row'
//             style={{
//               backgroundColor: '#FFF',
//               minHeight: '400px',
//               padding: '60px 0',
//               margin: '0',
//             }}
//           >
//             <div className='col-12'>
//               <div className='container'>
//                 <div className='row align-items-center'>
//                   <div className='col-lg-4 col-md-5 col-12 mb-4 mb-md-0 d-flex justify-content-center'>
//                     <div style={{ maxWidth: '280px', width: '100%' }}>
//                       <img
//                         src={Doctor}
//                         alt='doctor-female'
//                         className='img-fluid'
//                         style={{
//                           zIndex: 2,
//                           maxWidth: '130%',
//                           height: 'auto',
//                         }}
//                       />
//                     </div>
//                   </div>
//                   <div className='col-lg-8 col-md-7 col-12'>
//                     <h2
//                       className='mb-4'
//                       style={{
//                         fontSize: 'clamp(1.6rem, 3.5vw, 2.2rem)',
//                         fontWeight: '600',
//                         lineHeight: '140%',
//                         fontFamily: 'Inter',
//                       }}
//                     >
//                       <span style={{ color: '#2D5272' }}>
//                         Community Medicine -
//                       </span>{' '}
//                       <span style={{ color: '#889E7E' }}>
//                         Bridging Gaps Between Community Medicine and Communities
//                       </span>
//                     </h2>
//                     <p
//                       style={{
//                         fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
//                         lineHeight: '180%',
//                         color: '#424242',
//                         maxWidth: '100%',
//                         wordWrap: 'break-word',
//                         fontFamily: 'Inter',
//                         fontWeight: '400',
//                         color: '#002740',
//                       }}
//                     >
//                       Transforming community medicine in India by addressing
//                       rural and urban healthcare gaps through stronger public
//                       participation, digital innovation, and preventive
//                       care—ensuring accessible, inclusive, and continuous health
//                       support for every community.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className='container-fluid p-0' style={{ overflowX: 'hidden' }}>
//           <section
//             className='row align-items-center min-vh-50 py-5'
//             style={{
//               background:
//                 'linear-gradient(90deg, #FAFDFF 0%, #E2F6FF 56.36%, #C3E9FB 100%)',
//             }}
//           >
//             <div className='col-lg-6 col-md-12 d-flex justify-content-center p-4'>
//               <div style={{ maxWidth: '400px', width: '100%' }}>
//                 <img
//                   src={Man}
//                   alt='man'
//                   className='img-fluid'
//                   style={{
//                     zIndex: 2,
//                     maxWidth: '100%',
//                     height: 'auto',
//                   }}
//                 />
//               </div>
//             </div>

//             <div className='col-lg-6 col-md-12 p-4'>
//               <div
//                 style={{
//                   maxWidth: '500px',
//                 }}
//               >
//                 <h1
//                   className='mb-4'
//                   style={{
//                     fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
//                     fontWeight: '600',
//                     lineHeight: '1.2',
//                   }}
//                 >
//                   <span style={{ color: '#2C5282' }}>
//                     Collaborate & Empower –
//                   </span>
//                   <br />
//                   <span style={{ color: '#68A085' }}>
//                     Partners Making a Difference
//                   </span>
//                 </h1>

//                 <p
//                   className='mb-4'
//                   style={{
//                     color: '#2C5282',
//                     fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
//                     lineHeight: '1.6',
//                   }}
//                 >
//                   True transformation happens when communities come together.
//                   Tesla Bird welcomes partners, educators, businesses, and
//                   policymakers to collaborate in shaping a healthier, more
//                   informed society. Whether it's through scholarships, training
//                   programs, financial literacy initiatives, internships, or
//                   mentorship, our partners play a vital role in empowering
//                   individuals and building a sustainable future.
//                 </p>

//                 <button
//                   className='btn d-flex align-items-center'
//                   style={{
//                     backgroundColor: 'transparent',
//                     border: 'none',
//                     color: '#2C5282',
//                     fontSize: '1.1rem',
//                     fontWeight: '600',
//                     padding: '0',
//                   }}
//                   onMouseEnter={() => setIsEnquireHovered(true)}
//                   onMouseLeave={() => setIsEnquireHovered(false)}
//                   onClick={() => navigate('/enquiry-form')}
//                 >
//                   <span
//                     style={{
//                       textDecoration: isEnquireHovered ? 'underline' : 'none',
//                       transition: 'text-decoration 0.3s ease',
//                     }}
//                   >
//                     Enquire Now
//                   </span>
//                   <span className='ms-2' style={{ fontSize: '1.2rem' }}>
//                     →
//                   </span>
//                 </button>
//               </div>
//             </div>
//           </section>
//         </div>

//         <div className='container-fluid p-0'>
//           <div className='row g-0'>
//             <div className='col-12'>
//               <div
//                 className='position-relative overflow-hidden'
//                 style={{
//                   background: '#fff',
//                   minHeight: '600px',
//                 }}
//               >
//                 <div
//                   className='position-absolute'
//                   style={{
//                     bottom: '-30%', // Push it below the container
//                     left: '50%', // Center horizontally
//                     transform: 'translateX(-50%)', // Truly center it
//                     width: '110%', // Tall shape for upward effect
//                     height: '120%', // Adjust to your need
//                     background: '#E1F8E8B8',
//                     borderRadius: '90%',
//                     zIndex: 1,
//                   }}
//                 ></div>

//                 <div
//                   className='container position-relative'
//                   style={{ zIndex: 2 }}
//                 >
//                   <div
//                     className='row align-items-center'
//                     style={{ minHeight: '500px', marginTop: '140px' }}
//                   >
//                     <h1
//                       className='fw-bold mb-4'
//                       style={{
//                         fontSize: 'clamp(2rem, 5vw, 3rem)',
//                         textAlign: 'center',
//                       }}
//                     >
//                       <span
//                         style={{
//                           color: '#2D5272',
//                           fontFamily: 'Inter',
//                           fontWeight: '600',
//                         }}
//                       >
//                         Giving Back –{' '}
//                       </span>
//                       <span
//                         style={{
//                           color: '#889E7E',
//                           fontFamily: 'Inter',
//                           fontWeight: '600',
//                         }}
//                       >
//                         A Commitment to the Underprivileged
//                       </span>
//                     </h1>
//                     {/* Content Column */}
//                     <div className='col-lg-7 col-md-8 col-12 pe-lg-5'>
//                       <div className='py-4 py-md-5'>
//                         {/* Heading */}

//                         {/* Description */}
//                         <p
//                           className='mb-4'
//                           style={{
//                             color: '#002740',
//                             fontSize: 'clamp(1rem, 2.5vw, 1.125rem)',
//                             lineHeight: '1.6',
//                             maxWidth: '600px',
//                             textAlign:
//                               window?.innerWidth < 768 ? 'center' : 'left',
//                             margin:
//                               window?.innerWidth < 768
//                                 ? '0 auto 1.5rem auto'
//                                 : '0 0 1.5rem 0',
//                             fontFamily: 'Inter',
//                           }}
//                         >
//                           We believe in inclusive growth and strive to ensure
//                           that knowledge, mental well-being, and opportunities
//                           reach those who need them the most. Through
//                           scholarships, digital literacy programs, health
//                           initiatives, and community-driven projects, Tesla Bird
//                           is committed to uplifting underprivileged individuals
//                           and helping them create a better future. By becoming a
//                           part of our platform, you're not just investing in
//                           yourself— you're contributing to a movement that
//                           empowers lives.
//                         </p>

//                         {/* CTA Button */}
//                         <div
//                           className='mt-4'
//                           style={{
//                             textAlign:
//                               window?.innerWidth < 768 ? 'center' : 'left',
//                           }}
//                         >
//                           <a
//                             href='/enquiry-form'
//                             className='d-inline-flex align-items-center text-decoration-none'
//                             style={{
//                               color: '#002740',
//                               fontWeight: '600',
//                               background: 'transparent',
//                               border: 'none',
//                               padding: '0',
//                               transition: 'transform 0.3s ease',
//                               cursor: 'pointer',
//                               fontFamily: 'Inter',
//                               fontSize: '18px',
//                               textDecoration: 'none',
//                             }}
//                             onMouseEnter={(e) => {
//                               e.currentTarget.style.transform =
//                                 'translateX(5px)'
//                               const textSpan =
//                                 e.currentTarget.querySelector(
//                                   '.hover-underline'
//                                 )
//                               if (textSpan)
//                                 textSpan.style.textDecoration = 'underline'

//                               const svg = e.currentTarget.querySelector('svg')
//                               if (svg) svg.style.transform = 'translateX(3px)'
//                             }}
//                             onMouseLeave={(e) => {
//                               e.currentTarget.style.transform = 'translateX(0)'
//                               const textSpan =
//                                 e.currentTarget.querySelector(
//                                   '.hover-underline'
//                                 )
//                               if (textSpan)
//                                 textSpan.style.textDecoration = 'none'

//                               const svg = e.currentTarget.querySelector('svg')
//                               if (svg) svg.style.transform = 'translateX(0)'
//                             }}
//                           >
//                             <span className='hover-underline'>Enquire Now</span>
//                             <svg
//                               className='ms-2'
//                               width='20'
//                               height='20'
//                               viewBox='0 0 24 24'
//                               fill='none'
//                               stroke='currentColor'
//                               strokeWidth='2'
//                               style={{
//                                 transition: 'transform 0.3s ease',
//                               }}
//                             >
//                               <path d='M5 12h14M12 5l7 7-7 7' />
//                             </svg>
//                           </a>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Illustration Column */}
//                     <div
//                       className='col-lg-5 col-md-4 col-12 d-flex justify-content-center'
//                       style={{
//                         marginTop: window?.innerWidth < 768 ? '2rem' : '0',
//                       }}
//                     >
//                       <div
//                         className='position-relative'
//                         style={{
//                           maxWidth: '400px',
//                           width: '100%',
//                         }}
//                       >
//                         <img
//                           src={HelpingGirl}
//                           alt='helping-girl'
//                           className='img-fluid'
//                           style={{
//                             zIndex: 2,
//                             maxWidth: '120%',
//                             height: 'auto',
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Mobile-specific styles */}
//           <style jsx>{`
//             @media (max-width: 768px) {
//               .container {
//                 padding-left: 1rem !important;
//                 padding-right: 1rem !important;
//               }
//             }

//             @media (max-width: 576px) {
//               h1 {
//                 font-size: 1.75rem !important;
//                 text-align: center !important;
//               }

//               p {
//                 font-size: 0.95rem !important;
//                 text-align: center !important;
//                 margin: 0 auto 1.5rem auto !important;
//               }

//               .btn-container {
//                 text-align: center !important;
//                 width: 100% !important;
//               }
//             }
//           `}</style>
//         </div>

//         <Footer />
//       </div>
//     </>
//   )
// }

// export default NewLandingPage

import { useEffect, useState } from 'react'
import EarthOne from '../Assets/Assests/Hand-Earth-1.png'
import EarthTwo from '../Assets/Assests/Hand-Earth-2.png'
import EarthThree from '../Assets/Assests/Hand-Earth-3.png'
import Face from '../Assets/Assests/face-pot.png'
import HelpingGirl from '../Assets/Assests/Helping-girl.png'
import gif from '../Assets/Assests/hii-circle-gif.gif'
import Man from '../Assets/Assests/man-collaboration.png'
import Doctor from '../Assets/Assests/female-doctor.jpg'
import Header from './Header'
import Footer from './Footer'
import { Link, useNavigate } from 'react-router-dom'

const NewLandingPage = () => {
  const navigate = useNavigate()

  const images = [EarthOne, EarthTwo, EarthThree]
  const [currentIndex, setCurrentIndex] = useState(0)
  const [fade, setFade] = useState(true)
  const [isDonateHovered, setIsDonateHovered] = useState(false)
  const [isMemberHovered, setIsMemberHovered] = useState(false)
  const [isMemberTwoHovered, setIsMemberTwoHovered] = useState(false)
  const [isEnquireHovered, setIsEnquireHovered] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false) // start fade out

      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % images.length)
        setFade(true) // start fade in
      }, 300) // fade out duration
    }, 3000) // time each image stays on screen

    return () => clearInterval(interval)
  }, [])

  return (
    <>
      <Header />

      <div className='min-vh-100' style={{ backgroundColor: '#2D5272' }}>
        {/* Hero Section */}
        <header
          id='home'
          className='container-fluid text-white py-4 py-md-5 mt-3'
          style={{ background: '#2D5272' }}
        >
          <div className='container'>
            <div
              className='row align-items-center g-4'
              style={{ minHeight: '60vh', marginTop: '50px' }}
            >
              <div className='col-12 col-lg-6 order-2 order-lg-1'>
                <h1
                  className='fw-bold mb-3 mb-md-4 text-center text-lg-start'
                  style={{
                    marginTop: '10px',
                    fontFamily: 'Inter',
                    fontWeight: '700',
                    fontSize: 'clamp(2rem, 6vw, 3.4rem)',
                    lineHeight: '1.2',
                  }}
                >
                  Wellness initiatives, reimagined for today's world.
                </h1>
                <p
                  className='mb-3 mb-md-4 text-center text-lg-start'
                  style={{
                    opacity: '2',
                    zIndex: 3,
                    fontSize: 'clamp(0.9rem, 2.5vw, 1.1rem)',
                    lineHeight: '1.6',
                  }}
                >
                  Tesla Bird is India's first AI-powered mental wellness
                  platform inspired by the genius and struggles of Nikola Tesla.
                </p>
                <p
                  className='mt-3 mt-md-4 mb-4 text-center text-lg-start'
                  style={{
                    opacity: '2',
                    zIndex: 3,
                    fontSize: 'clamp(0.9rem, 2.5vw, 1.1rem)',
                    lineHeight: '1.6',
                  }}
                >
                  Join hands in shaping a kinder, stronger, and more mentally
                  aware society.
                </p>

                <div className='d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-start align-items-center'>
                  {/* Donate Button */}
                  <button
                    className='btn px-4 py-2'
                    style={{
                      backgroundColor: '#002740',
                      color: 'white',
                      borderRadius: '50px',
                      textDecoration: isDonateHovered ? 'underline' : 'none',
                      width: '140px',
                      height: '53px',
                      transition: 'all 0.3s ease',
                      fontSize: 'clamp(0.9rem, 2vw, 1rem)',
                    }}
                    onMouseEnter={() => setIsDonateHovered(true)}
                    onMouseLeave={() => setIsDonateHovered(false)}
                    onClick={() => navigate('/donate-form')}
                  >
                    Donate
                  </button>

                  {/* Become a Member Button */}
                  <Link
                    to='/membership'
                    className='btn px-4 py-2 d-flex justify-content-center align-items-center text-decoration-none'
                    style={{
                      border: '2px solid #FFFFFF',
                      color: '#FFFFFF',
                      borderRadius: '50px',
                      textDecoration: isMemberHovered ? 'underline' : 'none',
                      width: '200px',
                      height: '53px',
                      transition: 'all 0.3s ease',
                      fontSize: 'clamp(0.9rem, 2vw, 1rem)',
                    }}
                    onMouseEnter={() => setIsMemberHovered(true)}
                    onMouseLeave={() => setIsMemberHovered(false)}
                  >
                    Become a Member
                  </Link>
                </div>
              </div>

              {/* Animated Image Section */}
              <div className='col-12 col-lg-6 d-flex justify-content-center position-relative order-1 order-lg-2'>
                <div
                  className='image-wrapper'
                  style={{
                    width: '100%',
                    maxWidth: '400px',
                    height: 'clamp(250px, 50vw, 400px)',
                    position: 'relative',
                    overflow: 'hidden',
                  }}
                >
                  <img
                    src={images[currentIndex] || '/placeholder.svg'}
                    alt='Hero'
                    className='img-fluid'
                    style={{
                      zIndex: 2,
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      opacity: fade ? 1 : 0,
                      transition: 'opacity 0.5s ease-in-out',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* Tesla Bird Initiative Section */}
        <div className='container-fluid' style={{ backgroundColor: '#fff' }}>
          <div className='container py-4 py-md-5'>
            <h1
              className='fw-normal mb-3 mb-md-4 text-center text-lg-start'
              style={{
                marginTop: '30px',
                fontFamily: 'Inter',
                fontWeight: '600',
                fontSize: 'clamp(1.8rem, 5vw, 2.8rem)',
                color: '#2D5272',
                lineHeight: '1.3',
              }}
            >
              Tesla Bird Mental Wellness Initiative –{' '}
              <span
                className='d-block d-lg-inline'
                style={{
                  fontFamily: 'Inter',
                  fontWeight: '600',
                  fontSize: 'clamp(1.8rem, 5vw, 2.8rem)',
                  color: '#889E7E',
                }}
              >
                A Stronger Mind for a Better Tomorrow
              </span>
            </h1>

            <div
              className='row align-items-center g-4'
              style={{
                minHeight: '70vh',
                marginTop: '30px',
              }}
            >
              <div className='col-12 col-lg-6 order-2 order-lg-1'>
                <p
                  className='mb-3 mb-md-4 text-center text-lg-start'
                  style={{
                    opacity: '2',
                    zIndex: 3,
                    color: '#002740',
                    fontFamily: 'Inter',
                    fontWeight: '400',
                    fontSize: 'clamp(0.9rem, 2.5vw, 1.125rem)',
                    lineHeight: '1.6',
                  }}
                >
                  In today's fast-paced world, mental wellness is one of the
                  most urgent challenges—especially in India, where stress,
                  anxiety, and burnout have reached alarming levels. Tesla Bird
                  is a revolutionary AI-powered platform designed to tackle this
                  crisis by blending advanced technology, scientific research,
                  and human empathy.
                </p>
                <p
                  className='mb-3 mb-md-4 text-center text-lg-start'
                  style={{
                    opacity: '2',
                    zIndex: 3,
                    color: '#002740',
                    fontFamily: 'Inter',
                    fontWeight: '400',
                    fontSize: 'clamp(0.9rem, 2.5vw, 1.125rem)',
                    lineHeight: '1.6',
                  }}
                >
                  Named in honor of Nikola Tesla—who, despite his brilliance,
                  struggled with nervous disorders and emotional
                  breakdowns—Tesla Bird aims to do for mental health what Tesla
                  did for electricity: bring light. We strive to illuminate
                  minds with peace, purpose, and emotional strength.
                </p>
                <p
                  className='mb-4 text-center text-lg-start'
                  style={{
                    opacity: '2',
                    zIndex: 3,
                    color: '#002740',
                    fontFamily: 'Inter',
                    fontWeight: '400',
                    fontSize: 'clamp(0.9rem, 2.5vw, 1.125rem)',
                    lineHeight: '1.6',
                  }}
                >
                  India's mental health crisis is escalating rapidly. According
                  to NIMHANS, 1 in 7 Indians suffers from some form of mental
                  disorder. Students face intense academic pressure and social
                  expectations, while professionals battle long hours, digital
                  fatigue, and poor work-life balance—leading to anxiety,
                  depression, and sleep issues. A 2024 WHO report ranked India
                  among the top five most stressed nations globally.
                </p>

                <div className='d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-start align-items-center'>
                  <button
                    className='btn px-4 py-2'
                    style={{
                      backgroundColor: '#002740',
                      color: 'white',
                      borderRadius: '50px',
                      textDecoration: isDonateHovered ? 'underline' : 'none',
                      width: '140px',
                      height: '53px',
                      transition: 'all 0.3s ease',
                      fontSize: 'clamp(0.9rem, 2vw, 1rem)',
                    }}
                    onMouseEnter={() => setIsDonateHovered(true)}
                    onMouseLeave={() => setIsDonateHovered(false)}
                    onClick={() => navigate('/donate-form')}
                  >
                    Donate
                  </button>
                  <Link
                    to='/membership'
                    className='btn px-4 py-2 d-flex justify-content-center align-items-center text-decoration-none'
                    style={{
                      border: '2px solid #889E7E',
                      borderColor: isMemberTwoHovered ? '#889E7E' : '#889E7E',
                      backgroundColor: isMemberTwoHovered
                        ? '#002740'
                        : 'transparent',
                      color: '#889E7E',
                      borderRadius: '50px',
                      width: '200px',
                      height: '53px',
                      borderWidth: '2px',
                      transition: 'all 0.3s ease',
                      fontSize: 'clamp(0.9rem, 2vw, 1rem)',
                    }}
                    onMouseEnter={() => setIsMemberTwoHovered(true)}
                    onMouseLeave={() => setIsMemberTwoHovered(false)}
                  >
                    Become a Member
                  </Link>
                </div>
              </div>

              {/* Images */}
              <div className='col-12 col-lg-6 d-flex justify-content-center position-relative order-1 order-lg-2'>
                <div className='d-none d-md-block'>
                  <img
                    src={Face || '/placeholder.svg'}
                    alt='face'
                    className='img-fluid'
                    style={{
                      zIndex: 2,
                      maxWidth: '100%',
                      height: 'auto',
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Aarava and Community Medicine Sections */}
        <div
          className='container-fluid p-0'
          style={{ backgroundColor: 'white' }}
        >
          {/* Aarava Section */}
          <div className='container py-4 py-md-5'>
            <div
              className='row g-0'
              style={{
                backgroundColor: '#E3F2FD',
                minHeight: '300px',
                padding: '40px 20px',
                margin: '0',
                borderRadius: '15px',
              }}
            >
              <div className='col-12'>
                <div className='container'>
                  <div className='row align-items-center g-4'>
                    <div className='col-12 col-lg-8 col-md-7 order-2 order-md-1'>
                      <h1
                        className='mb-3 mb-md-4 text-center text-md-start'
                        style={{
                          fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
                          fontWeight: '600',
                          lineHeight: '1.4',
                          fontFamily: 'Inter',
                        }}
                      >
                        <span style={{ color: '#2D5272' }}>Aarava- </span>
                        <span style={{ color: '#889E7E' }}>
                          AI Wellness Companion
                        </span>
                      </h1>
                      <p
                        className='text-center text-md-start'
                        style={{
                          fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                          lineHeight: '1.8',
                          color: '#002740',
                          maxWidth: '100%',
                          wordWrap: 'break-word',
                          fontFamily: 'Inter',
                          fontWeight: '400',
                        }}
                      >
                        At the heart of Tesla Bird is Aarava—our AI-powered
                        therapy companion that's here for you, 24/7, in the
                        languages you feel most at home with. Aarava gently
                        blends proven techniques like Cognitive Behavioral
                        Therapy (CBT), mindfulness, and behavioral
                        nudging—shaped to fit the emotional rhythms and cultural
                        realities of life in India and beyond.
                      </p>
                    </div>
                    <div className='col-12 col-lg-4 col-md-5 d-flex justify-content-center order-1 order-md-2'>
                      <img
                        src={gif || '/placeholder.svg'}
                        alt='Loading...'
                        className='img-fluid'
                        style={{ maxWidth: '100%', height: 'auto' }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Community Medicine Section */}
          <div
            className='row g-0'
            style={{
              backgroundColor: '#FFF',
              minHeight: '400px',
              padding: '60px 20px',
              margin: '0',
            }}
          >
            <div className='col-12'>
              <div className='container'>
                <div className='row align-items-center g-4'>
                  <div className='col-12 col-lg-4 col-md-5 d-flex justify-content-center order-1 order-md-1'>
                    <div style={{ maxWidth: '280px', width: '100%' }}>
                      <img
                        src={Doctor || '/placeholder.svg'}
                        alt='doctor-female'
                        className='img-fluid rounded'
                        style={{
                          zIndex: 2,
                          maxWidth: '100%',
                          height: 'auto',
                        }}
                      />
                    </div>
                  </div>
                  <div className='col-12 col-lg-8 col-md-7 order-2 order-md-2'>
                    <h2
                      className='mb-3 mb-md-4 text-center text-md-start'
                      style={{
                        fontSize: 'clamp(1.4rem, 3.5vw, 2.2rem)',
                        fontWeight: '600',
                        lineHeight: '1.4',
                        fontFamily: 'Inter',
                      }}
                    >
                      <span style={{ color: '#2D5272' }}>
                        Community Medicine -
                      </span>{' '}
                      <span style={{ color: '#889E7E' }}>
                        Bridging Gaps Between Community Medicine and Communities
                      </span>
                    </h2>
                    <p
                      className='text-center text-md-start'
                      style={{
                        fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                        lineHeight: '1.8',
                        color: '#002740',
                        maxWidth: '100%',
                        wordWrap: 'break-word',
                        fontFamily: 'Inter',
                        fontWeight: '400',
                      }}
                    >
                      Transforming community medicine in India by addressing
                      rural and urban healthcare gaps through stronger public
                      participation, digital innovation, and preventive
                      care—ensuring accessible, inclusive, and continuous health
                      support for every community.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Collaboration Section */}
        <div className='container-fluid p-0' style={{ overflowX: 'hidden' }}>
          <section
            className='row align-items-center min-vh-50 py-4 py-md-5 g-0'
            style={{
              background:
                'linear-gradient(90deg, #FAFDFF 0%, #E2F6FF 56.36%, #C3E9FB 100%)',
            }}
          >
            <div className='col-12 col-lg-6 d-flex justify-content-center p-3 p-md-4 order-1 order-lg-1'>
              <div style={{ maxWidth: '400px', width: '100%' }}>
                <img
                  src={Man || '/placeholder.svg'}
                  alt='man'
                  className='img-fluid'
                  style={{
                    zIndex: 2,
                    maxWidth: '100%',
                    height: 'auto',
                  }}
                />
              </div>
            </div>

            <div className='col-12 col-lg-6 p-3 p-md-4 order-2 order-lg-2'>
              <div
                style={{
                  maxWidth: '500px',
                  margin: '0 auto',
                }}
              >
                <h1
                  className='mb-3 mb-md-4 text-center text-lg-start'
                  style={{
                    fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
                    fontWeight: '600',
                    lineHeight: '1.2',
                  }}
                >
                  <span style={{ color: '#2C5282' }}>
                    Collaborate & Empower –
                  </span>
                  <br />
                  <span style={{ color: '#68A085' }}>
                    Partners Making a Difference
                  </span>
                </h1>

                <p
                  className='mb-4 text-center text-lg-start'
                  style={{
                    color: '#2C5282',
                    fontSize: 'clamp(0.9rem, 2vw, 1.1rem)',
                    lineHeight: '1.6',
                  }}
                >
                  True transformation happens when communities come together.
                  Tesla Bird welcomes partners, educators, businesses, and
                  policymakers to collaborate in shaping a healthier, more
                  informed society. Whether it's through scholarships, training
                  programs, financial literacy initiatives, internships, or
                  mentorship, our partners play a vital role in empowering
                  individuals and building a sustainable future.
                </p>

                <div className='text-center text-lg-start'>
                  <button
                    className='btn d-inline-flex align-items-center'
                    style={{
                      backgroundColor: 'transparent',
                      border: 'none',
                      color: '#2C5282',
                      fontSize: 'clamp(1rem, 2.5vw, 1.1rem)',
                      fontWeight: '600',
                      padding: '0',
                    }}
                    onMouseEnter={() => setIsEnquireHovered(true)}
                    onMouseLeave={() => setIsEnquireHovered(false)}
                    onClick={() => navigate('/enquiry-form')}
                  >
                    <span
                      style={{
                        textDecoration: isEnquireHovered ? 'underline' : 'none',
                        transition: 'text-decoration 0.3s ease',
                      }}
                    >
                      Enquire Now
                    </span>
                    <span className='ms-2' style={{ fontSize: '1.2rem' }}>
                      →
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* Giving Back Section */}
        <div className='container-fluid p-0'>
          <div className='row g-0'>
            <div className='col-12'>
              <div
                className='position-relative overflow-hidden'
                style={{
                  background: '#fff',
                  minHeight: '600px',
                }}
              >
                <div
                  className='position-absolute'
                  style={{
                    bottom: '-30%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '110%',
                    height: '120%',
                    background: '#E1F8E8B8',
                    borderRadius: '90%',
                    zIndex: 1,
                  }}
                ></div>

                <div
                  className='container position-relative'
                  style={{ zIndex: 2 }}
                >
                  <div
                    className='row align-items-center g-4'
                    style={{
                      minHeight: '500px',
                      marginTop: '80px',
                      paddingTop: '60px',
                    }}
                  >
                    <div className='col-12 mb-4'>
                      <h1
                        className='fw-bold text-center'
                        style={{
                          fontSize: 'clamp(1.8rem, 5vw, 3rem)',
                          marginBottom: '2rem',
                        }}
                      >
                        <span
                          style={{
                            color: '#2D5272',
                            fontFamily: 'Inter',
                            fontWeight: '600',
                          }}
                        >
                          Giving Back –{' '}
                        </span>
                        <span
                          style={{
                            color: '#889E7E',
                            fontFamily: 'Inter',
                            fontWeight: '600',
                          }}
                        >
                          A Commitment to the Underprivileged
                        </span>
                      </h1>
                    </div>

                    {/* Content Column */}
                    <div className='col-12 col-lg-7 order-2 order-lg-1'>
                      <div className='py-3 py-md-4'>
                        {/* Description */}
                        <p
                          className='mb-4 text-center text-lg-start'
                          style={{
                            color: '#002740',
                            fontSize: 'clamp(1rem, 2.5vw, 1.125rem)',
                            lineHeight: '1.6',
                            maxWidth: '600px',
                            margin: '0 auto 1.5rem auto',
                            fontFamily: 'Inter',
                          }}
                        >
                          We believe in inclusive growth and strive to ensure
                          that knowledge, mental well-being, and opportunities
                          reach those who need them the most. Through
                          scholarships, digital literacy programs, health
                          initiatives, and community-driven projects, Tesla Bird
                          is committed to uplifting underprivileged individuals
                          and helping them create a better future. By becoming a
                          part of our platform, you're not just investing in
                          yourself— you're contributing to a movement that
                          empowers lives.
                        </p>

                        {/* CTA Button */}
                        <div className='mt-4 text-center text-lg-start'>
                          <a
                            href='/enquiry-form'
                            className='d-inline-flex align-items-center text-decoration-none'
                            style={{
                              color: '#002740',
                              fontWeight: '600',
                              background: 'transparent',
                              border: 'none',
                              padding: '0',
                              transition: 'transform 0.3s ease',
                              cursor: 'pointer',
                              fontFamily: 'Inter',
                              fontSize: 'clamp(1rem, 2.5vw, 1.125rem)',
                              textDecoration: 'none',
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform =
                                'translateX(5px)'
                              const textSpan =
                                e.currentTarget.querySelector(
                                  '.hover-underline'
                                )
                              if (textSpan)
                                textSpan.style.textDecoration = 'underline'

                              const svg = e.currentTarget.querySelector('svg')
                              if (svg) svg.style.transform = 'translateX(3px)'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = 'translateX(0)'
                              const textSpan =
                                e.currentTarget.querySelector(
                                  '.hover-underline'
                                )
                              if (textSpan)
                                textSpan.style.textDecoration = 'none'

                              const svg = e.currentTarget.querySelector('svg')
                              if (svg) svg.style.transform = 'translateX(0)'
                            }}
                          >
                            <span className='hover-underline'>Enquire Now</span>
                            <svg
                              className='ms-2'
                              width='20'
                              height='20'
                              viewBox='0 0 24 24'
                              fill='none'
                              stroke='currentColor'
                              strokeWidth='2'
                              style={{
                                transition: 'transform 0.3s ease',
                              }}
                            >
                              <path d='M5 12h14M12 5l7 7-7 7' />
                            </svg>
                          </a>
                        </div>
                      </div>
                    </div>

                    {/* Illustration Column */}
                    <div className='col-12 col-lg-5 d-flex justify-content-center order-1 order-lg-2'>
                      <div
                        className='position-relative'
                        style={{
                          maxWidth: '400px',
                          width: '100%',
                        }}
                      >
                        <img
                          src={HelpingGirl || '/placeholder.svg'}
                          alt='helping-girl'
                          className='img-fluid'
                          style={{
                            zIndex: 2,
                            maxWidth: '100%',
                            height: 'auto',
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  )
}

export default NewLandingPage
